import { Text as ChakraText } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type TextProps = ComponentPropsWithRef<typeof ChakraText>;

export function Text(props: TextProps) {
  return <ChakraText {...props} />;
}
